import { object } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object()

export const url = () => `/v1/me`
